

export const selectDataLayersViewFidersDistances = (state) => state?.helper?.layers?.dataLayers?.viewFiderDistances
export const selectDataLayersViewviewProjectStatus = (state) => state?.helper?.layers?.dataLayers?.viewProjectStatus